// extracted by mini-css-extract-plugin
export default {"filterAccordionContainer":"FilterAccordionGroup__filterAccordionContainer___dPhWN"};